// App
import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';

// Components
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';

// Misc / utils
import controller from './controller';
import stringHelper from 'app/shared/utils/stringHelper';
import { BuildingArticleGroup, BuildingHdpGroupBeds, BuildingHdpGroupPrice, UnitList } from './styles';
import { emitTrackClicksIntoPropertyEvent } from 'app/shared/models/Clickstream/ListingCardClickstreamEvents';

import type { SimilarListingDetails } from 'app/types/similarListingDetails.type';

type BuildingUnitGroupProps = {
  bedCount: number | string;
  unitType: Array<SimilarListingDetails>;
};

const BEDROOM_COUNT_MAP: Record<string | number, string> = {
  0: 'Studio',
  1: '1 bedroom',
  2: '2 bedrooms',
  3: '3 bedrooms',
  4: '4+ bedrooms',
  r4r: 'Room for rent',
};
const StyledDarkTextSpan = styled.span`
  color: ${colors['$hpx-grey-600']};
`;
const BuildingUnitGroup = ({ bedCount, unitType }: BuildingUnitGroupProps) => {
  const unitTypeLength = unitType.length;

  const getMatchingUnitsString = (numOfUnits: number) => {
    return stringHelper.pluralize(numOfUnits, 'unit', 'units');
  };

  return (
    <BuildingArticleGroup>
      <BuildingHdpGroupBeds>
        {BEDROOM_COUNT_MAP[bedCount]}
        <StyledDarkTextSpan> — {getMatchingUnitsString(unitTypeLength)}</StyledDarkTextSpan>
      </BuildingHdpGroupBeds>
      <BuildingHdpGroupPrice>{controller.getMinMaxPriceOfUnits(unitType)}</BuildingHdpGroupPrice>

      <UnitList>
        {unitType.map((unit) => {
          return (
            <ListingWrapper
              listing={unit}
              key={unit.aliasEncoded}
              onClick={() =>
                emitTrackClicksIntoPropertyEvent({
                  listing: unit,
                  triggerLocation: 'building_unit_card',
                })
              }
              triggerLocation="home_details"
              triggerObject="home_details_component|more_from_provider"
            />
          );
        })}
      </UnitList>
    </BuildingArticleGroup>
  );
};

export default BuildingUnitGroup;
